import React from "react";

const year = new Date().getFullYear();
function Footer() {
    return (
       <footer className="footer">
        <p>&copy;{year} Eric Chung ⋅ Handcoded with ♥</p>
      </footer>
    );
    }

    export default Footer;

    